import { render, staticRenderFns } from "./TasksView.vue?vue&type=template&id=7d642f28&scoped=true&"
import script from "./TasksView.vue?vue&type=script&lang=js&"
export * from "./TasksView.vue?vue&type=script&lang=js&"
import style0 from "./TasksView.vue?vue&type=style&index=0&id=7d642f28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d642f28",
  null
  
)

export default component.exports